// tslint:disable:file-name-casing
import { ApiIssueStatus, ApiMidOffice, ApiPricingXRank, ApiPricingXState, ApiPricingXTarget, ApiPricingXType, } from "./ApiSearchParameters";
import { BookingXStatus } from "libraries/component/booking/booking-status/booking-status.service";
import {
    BookingType,
    BookingXType,
    Keyword,
    LuggageType,
    PersonRole,
    PriceRateXRole,
    TravellerXGender,
    TravellerXTitle,
    TravellerXType,
    XChannel,
} from "./get-bookings.enum";
import { IAgency } from "libraries/service/resources/model/booking/IAgency";
import { IAgentResult } from "libraries/service/resources/model/booking/IAgent";
import { IAirTotal } from "libraries/service/resources/model/search/air/IAirTotal";
import { RuleType } from "libraries/component/booking-information/components/booking-price-card/components/conditions-tab/ICondition";
import { SectorXType } from "../../model/search/air/IAirSector";
import { IBookingHostCode } from "./import.interface";
import { EGender } from "../../hotel/ISearchParameters";
import { EXRateType, ITotal } from "libraries/interfaces/ITotal";
import { IAddress } from "libraries/hotel/models/address";
import { ILuggage, RestrictionUnit } from "../../model/booking/air/IAirPrice";
import { EInterfaceValues } from "libraries/component/interface-flag/interface-flag.component";
import {FareOptimisationOfferType} from "@afidium/ts-facade/model/fareOptimisationOfferType";
import {FareComponentInBookingType} from "@afidium/ts-facade";
import {FareOptimisationType} from "@afidium/ts-facade/model/fareOptimisationType";

export const sourceTicketBooking: string = "booking";

export enum ECouponStatus {
    openForUse = "OpenForUse",
    airportControl = "AirportControl",
    checkedIn = "CheckedIn",
    boarded = "Boarded",
    notified = "Notified",
    irregularOperations = "IrregularOperations",
    suspend = "Suspend",
    suspended = "Suspended",
    unavailable = "Unavailable",
    used = "Used",
    refunded = "Refunded",
    closed = "Closed",
    convertedToFIM = "ConvertedToFIM",
    printed = "Printed",
    exchanged = "Exchanged",
    void = "Void",
    unknown = "Unknown",
}

export interface IBookingIdentifier {
    syscode: string;
}

export interface IGetBookingOptions {
    computeCancellable?: boolean;
    computeIssuable?: boolean;
    computeVoidable?: boolean;
}

export interface IGetVehicleRentalBookingOptions {
    host: string;
    languageCode: string;
    format: string;
}

export interface IGetBookingsCommonResponse {
    action: IAction[];
    agency: IAgency;
    agent: IAgentResult;
    begin: string;
    code: string;
    customer: ICustomer;
    end: string;
    externalBooking: IExternalBooking[];
    fareComponent?: IFareComponent[];
    group?: IGroup;
    host: string;
    invoicing?: IRemark[];
    issueStatus: ApiIssueStatus;
    itinerary: IItinerary[];
    matchWeight: number;
    note?: IRemark[];
    osi?: IOsi[];
    owner: IOwner;
    price: IPrice[];
    product: IProduct[];
    rule: IRule[];
    remark: IRemark[];
    syscode: string;
    ticket?: ITicket[];
    ticketNewArray?: ITicket[];
    total: IAirTotal[];
    traveller?: ITraveller[];
    type?: BookingType[];
    vendorAlert?: IVendorAlert[];
    version?: string;
    whenCreated: string;
    whenLastUpdated: string;
    whenToIssue?: string;
    whenIssued?: string;
    wStatus: string;
    xStatus: BookingXStatus;
    xTarget: string;
    xType: BookingXType;
    booking?: any;
    computed?: {
        issuable?: boolean;
        cancellable?: boolean;
        voidable?: boolean;
    };
    operations?: IBookingOperation[];
    eligibility?: IBookingEligibility[];
    sapeigBalance?: IBookingSapeigBalance;
    carrier?: ICodeName;
    operationArray?: any;
    service?: any;
}

export interface IBookingSapeigBalance {
    booking: string;
    details: IBookingSapeigBalancePriceDetail[];
    whenCreated: string;
    whenLastUpdated: string;
}
export interface IBookingSapeigBalancePriceDetail {
    currency: string;
    decimals: number;
    due: number;
    totalExpected: number;
    status: ESapeigBalanceStatus;
    whenLastUpdated: string;
}

export enum ESapeigBalanceStatus {
    "paid"= "Paid",
    "PAID"= "PAID",
    "none" = "None",
    "partial" = "Partial",
}
export interface IBookingOperation {
    booking: string;
    operations: IServiceOperation[];
    service: IServiceInfo;
    timestamp: string;
}

export interface IServiceOperation {
    messages: string[];
    /** Should be 'code'. */
    name: string;
    title: string;
    timestamp: string;
}

export interface IServiceInfo {
    code: string;
    title: string;
}

export interface IBookingEligibility {
    booking: string;
    code: string;
    title: string;
    status: string;
    details: IEligibilityDetails;
    whenCreated: string;
    whenLastUpdated: string;
}

export interface IEligibilityDetails {
    type?: string;
    event?: string;
    start?: string;
    end?: string;
}

export type TGetBookingResponse = IGetBookingsStayResponse | IGetBookingsAirResponse | IGetBookingsVehicleRentalResponse;

export interface IGetBookingsStayResponse extends IGetBookingsCommonResponse {
    accomodation: IAccommodation[];
    duration: IDurationDayNight;
    property: IProperty[];
    sector: ISectorStay[];
    service: IService[];
    site: {
        text: string;
        xChannel: XChannel;
    };
    whenLastToCancelWithoutPenalty: string;
    vendor: IGetBookingsStayVendor;
}

export interface IGetBookingsVehicleRentalResponse extends IGetBookingsCommonResponse {
    sector?: any;
}

export interface IGetBookingsStayVendor {
    telephone: ITelephone;
    message: IGetBookingsStayVendorMessage;
    logo: {
        url: string;
        width: string;
        height: string;
    };
    host: IBookingHostCode;
    email: {
        text: string;
    };
    agent: {
        name: string;
    };
    address: IAddress;
}

export interface IGetBookingsStayVendorMessage {
    language: string;
    paragraph: {
        title: string;
        url: string;
    };
}

export interface IDetailedWarning {
    wCode: string;
    code?: string;
    text: string;
}

export interface IGetBookingsAirResponse extends IGetBookingsCommonResponse {
    warningMessage?: string;
    detailedWarningArray?: IDetailedWarning[];
    carrier: ICarrier;
    from: IFromTo;
    payment?: {
        formOfPayment?: {
            type: string;
        };
        xRole?: string;
        whenDue?: string;
    };
    seatAssignment?: ISeatAssignment[];
    sector: ISectorAir[];
    ssr: ISsr[];
    to: IFromTo;
    whenToPay?: string;
    booking?: any;
    bookingExternalLink?: string;
    // tslint:disable-next-line:no-any
    service: any[];
    fareOptimisationArray: FareOptimisationType[];
}

export interface IFromTo {
    city: ICodeName;
    rank?: string;
    airport: ICodeName;
    country: ICodeName;
    terminal?: {
        code: string;
    };
}

interface ICodeName {
    code: string;
    name?: string;
    source?: string;
}

export interface IXId {
    firstName?: string;
    lastName?: string;
    xId?: string;
    xType?: string;
    xRef?: string;
}

export interface IText {
    text: string;
}

export interface IXRole {
    xRole: PriceRateXRole;
}

export interface IForUnit {
    for: string;
    unit: string;
}

export interface IRestriction {
    max: number; //temporary, need API fix there
    unit: string;
    topic: string;
}

export interface IRule {
    in?: LuggageType;
    xId?: string;
    price?: IXId;
    xType: RuleType;
    sector?: IXId[];
    quantity?: IForUnit[];
    traveller?: IXId[];
    restriction?: IRestriction[];
    text?: string;
    penalty?: IRulePenalty[];
    accomodation?: IXId;
}

interface IGroup {
    key: string;
    name: string;
    person: number;
    remaining: number;
    xId: string;
}

export interface IRulePenalty {
    validity?: {
        validity?: IValidity;
        // cancellation replace validity
        cancellation?: IValidity;
        exchange?: {
            "countingFrom": string;
        };
    };
    unitValue?: string;
    percentage?: number;
    unitAmount?: number;
    currency?: string;
    decimals?: number; // shoulg be correected in API
    calculation?: {
        quantity: IForUnit;
    };
    eligibility?: IRulePenaltyEligibility[];
}

export interface ICustomer {
    key?: string;
    xId?: string;
    xTitle?: TravellerXTitle;
    title?: TravellerXTitle;
    lastName?: string;
    firstName?: string;
    traveller?: {
        xId: string;
        xType: string;
    };
    email?: IEmail[];
    address?: IAddress;
    telephone?: ITelephone | ITelephone[];
}

export interface IRemark {
    xId?: string;
    scope?: PersonRole;
    text: string[];
    whenLastUpdated?: string;
    keyword?: IPriceKeyword;
    /** Populated in non-GALILEO bookings; */
    syscode?: string;
    /** Populated in GALILEO bookings; */
    key?: string;
    noteXId?: string;
    noteScope?: PersonRole;
    noteText?: string[];
    noteWhenLastUpdated?: string;
    noteKeyword?: IPriceKeyword;
}

interface IRulePenaltyEligibility {
    sector?: IXId;
    accomodation?: IXId;
}

interface IOwner {
    agent: {
        code: string;
    };
    agency?: {
        code: string;
    };
    company: {
        code: string;
    };
}

export interface IEmail {
    key: string;
    text: string;
    xId: string;
}


export interface ITaxBreakdown {
    code: string;
    currency: string;
    decimals: number;
    unitValue: number;
    unitAmount: number;
}

export interface IOsi {
    vendor: {
        code: string;
    };
    key: string;
    text: string;
}

export interface IPriceDetail extends ITotal {
    accomodation?: IXId[];
    originalCurrency?: IOriginalCurrency;
    quantity?: number;
    retail?: ITotal[];
    sector?: IXId[];
    segment?: IXId[];
    service?: IXId;
    traveller?: IXId[];
    unitAmount?: number;
    unitValue?: number;
    xUnitAmount?: number; // still existing fields and returned by API OLD
    xUnitValue?: number; // still existing fields and returned by API OLD
    value: number;
    xUnitType?: string;
    xSellLocation?: XSellLocationEnum;
    detail?: {
        tax?: IPriceDetailDetail,
        fee?: IPriceDetailDetail,
    };
}

export enum XSellLocationEnum {
    local = "Local",
    merchant = "Merchant"
}

export interface IPriceDetailDetail extends ITotal {
    code: string;
    name: string;
    unitValue: 1470;
    unitAmount: 14.7;
    xSellLocation: XSellLocationEnum;
    originalCurrency?: IOriginalCurrency;
}

export interface ITaxPriceDetail extends IPriceDetail {
    taxBreakdown?: ITaxBreakdown[];
}

export interface IOriginalCurrency {
    value?: string | number;
    amount?: string | number;
    currency?: string;
    quantity?: string;
    unitValue?: string;
    unitAmount?: string;
}

export interface IPriceDetails {
    base: IPriceDetail[];
    fee?: IPriceDetail[];
    supplement?: IPriceDetail[];
    addon?: IPriceDetail;
    surcharge?: IPriceDetail[];
    tax?: ITaxPriceDetail[];
}

export interface IPriceTotal {
    tax?: ITotal;
    fee?: ITotal;
    addon?: ITotal;
    base?: ITotal;
    surcharge?: ITotal;
    total?: ITotal[] | ITotal;
}


export interface IPrice {
    detail?: IPriceDetails;
    key?: string;
    rate?: IXRole[];
    status?: string;
    total?: IPriceTotal;
    additionalTotal?: ITotal;
    type?: string;
    vendor?: {
        code: string;
        name?: string;
    };
    keyword?: IPriceKeyword[];
    validity?: {
        end: string;
    };
    margin?: IMargin;
    markup?: IMargin;
    wCode?: string;
    code?: string;
    sourceCode?: string;
    title?: string;
    xId?: string;
    xRole?: string;
    xState?: ApiPricingXState;
    xTarget?: ApiPricingXTarget;
    xType?: EXRateType;
    xRank?: ApiPricingXRank;
}

export interface IMargin {
    base: IReference;
    fee?: IReference;
    supplement?: IReference;
    surcharge?: IReference;
    tax?: IReference;
}

interface IReference {
    reference: number;
}

export interface IPriceKeyword {
    xCode: Keyword;
}

interface IAction {
    who?: string;
    type: string;
    when?: string;
    state: string;
    xCode: string;
    xPurpose: string;
    rule?: {
        code: {
            role: string;
            owner: string;
            value: number;
        };
    };
    agency?: {
        code: string;
    };
    whenDue?: string;
    xStatus?: string;
}

export interface IAgencyTelephone {
    key: string;
    xId: string;
    number: number;
    xScope: string;
}

export interface ISsr {
    code: string;
    key?: string;
    name: string;
    sector: IXId[];
    status: string;
    text: string;
    traveller: IXId[];
    vendor: { code: string; };
    xStatus: string;
    syscode?: string;
}

export interface ISeatAssignment {
    number: string;
    sector: IXId;
    traveller: IXId;
    xStatus: string;
}

export interface ITicket {
    number: string;
    // TODO Interface de price à enrichir
    price: IPriceTicket;
    sector?: ITicketSector[];
    sectorArray?: ITicketSector[];
    traveller: IXId;
    whenIssued?: {
        date?: string;
        value?: string;
    };
}

export interface IPriceTicket {
    detail: IDetailPriceTicket;
    total?: IAirTotal;
}

export interface IDetailPriceTicket {
    rate?: {
        ruleArray: IRuleTicket[];
        fareComponentArray: IFareComponentTicket[];
    };
}

export interface IRuleTicket {
    xRole: string;
    sectorArray: IXId[];
    luggage: ITicketLuggage;
}

export interface ITicketLuggage {
    xCategory: LuggageType;
    quantity: {
        max: number;
    };
    weight: {
        xUnit: RestrictionUnit;
        max: number;
    };
}

export interface IFareComponentTicket {
    from: ISectorFromTo;
    to: ISectorFromTo;
    class: string;
    sectorArray: IXId[];
    fareBasis: {
        code: string;
    };
}

export interface ITicketSector {
    xId: string;
    xRef: string;
    begin: ITicketDate;
    end: ITicketDate;
    carrier: ISectorCarrier;
    from: ISectorFromTo;
    to: ISectorFromTo;
    coupon: ICoupon;
    flight?: string;
    seat: ISeat;
    aircraft?: ICodeName;
    carbonFootprint?: ICarbonFootPrint;
    operatedBy?: {
        carrier: ICodeName;
    };
    voucher?: {
        number: string;
    };
}

export interface ISectorFromTo {
    airport: ISectorFromToAirportAndCity;
    city: ISectorFromToAirportAndCity;
    country: ISectorFromToCountry;
    terminal?: {
        code: string;
    };
}

export interface ISectorFromToAirportAndCity {
    iata: string;
    code?: string;
    name: { value: string; };
}

export interface ISectorFromToCountry {
    iso: string;
    name: { value: string; };
}

export interface ISeat {
    code: string;
    cabin: string;
    status: string;
    xStatus: string;
    quantity: number;
    source?: BookingType;
}

export interface ITicketDate {
    value: string;
    date: string;
    time: string;
    source?: string;
}

export interface ISectorCarrier {
    iata: string;
    flight: string;
    name: string;
    code?: string;
    source?: string;
}

interface ISectorCommon {
    begin: string;
    end: string;
    itinerary?: IXId;
    key?: string;
    product?: IXId;
    syscode?: string;
    xId: string;
    xStatus?: string;
    xType: SectorXType;
}

export interface ISectorAir extends ISectorCommon {
    index: number;
    category: string;
    aircraft: ICodeName;
    carrier: ICodeName;
    carbonFootprint?: ICarbonFootPrint;
    changeOfAircraft?: boolean;
    /** Optional for SABRE booking. */
    duration?: ISectorDurationMinute;
    flight: string;
    from: IFromTo;
    leg?: ILeg;
    operatedBy?: {
        carrier: ICodeName;
    };
    seat: ISeat;
    stop?: {
        duration: ISectorDurationMinute;
        airport: ICodeName;
    };
    to: IFromTo;
    xType: SectorXType.air;
    coupon?: ICoupon;
    marriageGroup?: string;
}

export interface ICoupon {
    index: number;
    xState: ECouponStatus;
    ticket: {
        index: number;
        number: number;
    };
}

export interface ISectorStay extends ISectorCommon {
    accomodation: IXId[];
    duration: IDurationDayNight;
    host?: string;
    in?: IIn;
    property: IXId;
    service?: IXId[];
    xType: SectorXType.stay;
    quantity: {
        room: number;
        adult?: number;
        child?: number;
        night?: number;
        infant?: number;
    };
}


export interface ICarbonFootPrint {
    xUnit: string;
    quantity: string;
    calculation: IForUnit;
    unitValue?: number;
    seat: ICarbonFootPrintSeat[];
}

interface ICarbonFootPrintSeat {
    xCabin: string;
}

interface ILeg {
    aircraft: ICodeName;
    duration: ISectorDurationMinute;
    flight: string;
    from: IFromTo;
    to: IFromTo;
}

interface IIn {
    city: ICodeName;
    location: ICodeName;
}

interface ISectorDurationMinute {
    minute: number;
}

export interface IDurationDayNight {
    day?: number;
    night: number;
}

interface ICarrier extends ICodeName {
    rank: string;
}

interface IProduct {
    xId: string;
    xType: string;
    sector: IXId[];
    xStatus: string;
}

interface IItinerary {
    accomodation?: IXId;
    product: IXId;
    property?: IXId;
    sector: IXId[];
    service?: IXId;
    syscode?: string;
    xId: string;
    xStatus: string;
    xType: string;
}

export interface ITraveller {
    birthDate?: string;
    firstName?: string;
    key?: string;
    lastName?: string;
    syscode?: string;
    xId: string;
    xTitle?: TravellerXTitle;
    title?: TravellerXTitle;
    xType: TravellerXType;
    telephone?: ITelephone | ITelephone[];
    email?: IEmail;
    address?: IAddress;
    xGender?: TravellerXGender;
    identityCard?: IIdentityInfo[];
    passport?: IIdentityInfo[];
    secureFlightPassengerData?: ISfpd;
    visa?: IIdentityInfo[];
    citizenShip?: ICitizenShip;
    frequentTravellerCard?: IFrequentTravellerCard[];
    givenName?: string[];
    signature?: string;
}

export interface IIdentityInfo {
    holder: IHolder;
    number: string;
    validity: IValidity;
    placeOfIssue: ICitizenShip;
}

export interface ISfpd {
    holder: IHolder;
}

export interface IFrequentTravellerCard {
    number: string;
    vendor: {
        code: string;
    };
}

export interface IValidity {
    end?: string;
    passEnd?: string;
    cardEnd?: string;
    begin?: string;
}

export interface IHolder {
    xGender: TravellerXGender | EGender;
    lastName: string;
    birthDate: string;
    firstName: string;
    citizenShip?: ICitizenShip;
    xTitle?: TravellerXTitle;
    title?: TravellerXTitle;
}

export interface ICitizenShip {
    country: ICountry;
    passCountry?: ICountry;
    cardCountry?: ICountry;
}

interface ICountry {
    code: string;
    email?: IEmail;
    address?: IAddress;
}

export interface IFareComponent {
    price: IXId;
    sector: IXId[];
    fareBasis: {
        code: string;
    };
    fareFamily: IFareFamily;
    traveller: IFareComponentTraveller[];
}

export interface IFareFamily extends ICodeName {
    syscode?: string;
    xId: string;
    traveller?: string[];
    segment?: string[];
    name: string;
    sector?: string[];
}

export interface IFareComponentTraveller {
    xId: string;
    xType?: string;
}

export interface IExternalBooking {
    host: string | IExternalBookingHost;
    origin?: string;
    xOrigin?: string;
    xStatus?: ApiMidOffice;
    code?: string;
    action?: IAction;
    status?: string;
    whenCreated?: string;
    interface?: EInterfaceValues;
}
export interface IExternalBookingHost {
    code: string;
    shortcut: string;
    interface?:  {
        name: EInterfaceValues
    };
}

export interface IService {
    code: string;
    language: string;
    mealplan: {
        xCode: string;
    };
    name: string;
    syscode: string;
    xId: string;
    xStatus?: string;
}

export interface IAccommodation {
    begin?: string;
    end?: string;
    duration?: {
        night: number;
        day: number;
    };
    property?: {
        xId: string;
    };
    code?: string;
    language: string;
    name: string;
    quantity: {
        infant: number;
        child: number;
        adult: number;
        night?: number;
    };
    syscode: string;
    traveller: IXId[];
    xId: string;
    xStatus?: string;
    xCode?: string;
    service?: IXId[];
}

export interface IVendorAlert {
    host?: string;
    vendor?: {
        code: string;
        name?: string;
    };
    key: string;
    text: string;
    whenCreated: string | Date;
    whenLastUpdated: string | Date;
}

export interface IProperty {
    xId: string;
    name?: string;
    rating?: IPropertyRating;
    address?: IAddress;
    telephone?: ITelephone[];
    site?: string;
    description?: IBookingPropertyDescription[];
}

export enum EXApply {
    mandatory = "Mandatory",
    optional = "Optional",
}

export enum EPropertyXCode {
    checkIn = 'CheckIn',
    checkOut = 'CheckOut',
    goodToKnow = 'GoodToKnow',
    fee = 'Fee',
}

export interface IPropertyXCodeAndXApply {
    xCode: EPropertyXCode;
    xApply?: EXApply;
}

export interface IBookingPropertyDescription {
    index: string;
    languageCode: string;
    textLines?: string[];
    title: string;
    types?: IPropertyXCodeAndXApply[];
}

export interface ITelephone {
    use?: string;
    type?: string;
    number: string;
    text?: string;
    xType?: string;
    xScope?: string;
    syscode?: string;
}

export interface IPropertyRating {
    code?: string;
    name?: string;
    value: number;
    xUnit: string;
}
